import { render, staticRenderFns } from "./MappingRenewalDetails.vue?vue&type=template&id=3944310a&scoped=true&"
import script from "./MappingRenewalDetails.vue?vue&type=script&lang=js&"
export * from "./MappingRenewalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944310a",
  null
  
)

export default component.exports